import request from '@/utils/request'

// 查询会员订阅档位列表
export function listSubscribeLevel(query) {
  return request({
    url: '/member/subscribe/level/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询会员订阅档位分页
export function pageSubscribeLevel(query) {
  return request({
    url: '/member/subscribe/level/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询会员订阅档位详细
export function getSubscribeLevel(data) {
  return request({
    url: '/member/subscribe/level/detail',
    method: 'get',
    params: data
  })
}

// 新增会员订阅档位
export function addSubscribeLevel(data) {
  return request({
    url: '/member/subscribe/level/add',
    method: 'post',
    data: data
  })
}

// 修改会员订阅档位
export function updateSubscribeLevel(data) {
  return request({
    url: '/member/subscribe/level/edit',
    method: 'post',
    data: data
  })
}

// 删除会员订阅档位
export function delSubscribeLevel(data) {
  return request({
    url: '/member/subscribe/level/delete',
    method: 'post',
    data: data
  })
}
